import { useState } from "react";
import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";

const dataFormatter = new Jsona();

const sessionsRecordingsApiService = async courseId =>
  new JsonApiService("sessions_recordings", {
    baseUrl: `${visionURL}/admin_console/api/content/courses/${courseId}`,
    credentials: "include"
  });

export const useSessionsRecordings = ({ courseId, status = "all" } = {}) => {
  const [isFetching, setIsFetching] = useState(false);
  const fetchSessionsRecordings = async ({ sortBy, page, filters }) => {
    setIsFetching(true);
    const service = await sessionsRecordingsApiService(courseId);
    const response = await service
      .page(page)
      .sort(sortBy)
      .where({ status: status })
      .all()
      .then(response => response.json());
    setIsFetching(false);
    return {
      data: dataFormatter.deserialize(response),
      totalCount: response.meta?.totalCount
    };
  };
  return {
    fetchSessionsRecordings,
    isFetching
  };
};
